import { render } from "./DialogHeader.vue?vue&type=template&id=f3c5d3ee&ts=true"
import script from "./DialogHeader.vue?vue&type=script&lang=ts"
export * from "./DialogHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__